import { AddressModel } from '@simploshop-models/address.model'
import { AddressType } from '@sim-api-enums/address'

interface Attributes {
    [ComplaintAddressModel.ATTR_TYPE]: AddressType

}

interface Embeds {
}

export class ComplaintAddressModel extends AddressModel<Attributes, Embeds> {
    static override key = 'ComplaintAddressModel'

    static readonly ATTR_TYPE = 'type'

    get type() {
        return this._getAttribute(ComplaintAddressModel.ATTR_TYPE)
    }

    isShipping() {
        return this.type === AddressType.SHIPPING
    }

    isBilling() {
        return this.type === AddressType.BILLING
    }
}
